import React from 'react'

import idx from 'idx'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'

const styles = theme => ({
  root: {
    width: 18,
    height: 18,
    fontSize: 10,
    fontWeight: 500,
    borderRadius: 9,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.white,
    backgroundColor: theme.palette.error.main,
  },
})

const PeopleRequestBadge = ({ classes, className, requestCount }) => {
  return requestCount > 0 ? (
    <div className={classNames(className, classes.root)}>{requestCount}</div>
  ) : null
}

PeopleRequestBadge.propTypes = {
  classes: PropTypes.object,
  className: PropTypes.string,
  requestCount: PropTypes.number,
}

function mapStateToProps(state) {
  return {
    requestCount: idx(state, _ => _.people.requests.count) || 0,
  }
}

export default connect(
  mapStateToProps,
  null
)(withStyles(styles)(PeopleRequestBadge))



// WEBPACK FOOTER //
// ./src/components/atoms/PeopleRequestsBadge.js